"use client";
import { useContext } from "react";
import ExploreVideos from "./ExploreVideos";
import { UserContext } from "@/context/UserContext";

export default function ExploreContent({ infiniteScroll = false }) {
  const { user } = useContext(UserContext);

  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-black/95 pt-2 pb-4">
      <div className="container mx-auto px-2 sm:px-3 lg:px-4">
        <div className="flex flex-col mb-2">
          <h2 className="text-lg sm:text-2xl md:text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-green-400 mb-0.5">
            Explore Videos
          </h2>
          <p className="text-gray-400 text-xs max-w-lg">
            Discover amazing videos created by our community
          </p>
        </div>

        <ExploreVideos 
          infiniteScroll={infiniteScroll} 
          userEmail={user?.email}
        />
      </div>
    </div>
  );
} 